import { SettingOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledSettingOutlined = styled(SettingOutlined)`
    font-size: 24px;
    transform-origin: center center;
    animation: appLoaderSpin 4s linear infinite;
    color: ${({ theme }) => theme.colors.primary};

    @keyframes appLoaderSpin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;
